import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import { Row, Col, Alert, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import axios from "axios";
import moment from "moment";

import Title from "./../../components/general/AdminPageTitle/AdminPageTitle";
import Table from "./../../components/general/Table/Table";
import Section from "./../../components/general/Section/Section";
// import Button from "./../../components/general/Button/Button";
import PlaceholderTruckForm from "./../../components/page/placeholderTrucks/PlaceholderTruckForm/PlaceholderTruckForm";
import EditPlaceholderModal from "./../../components/page/placeholderTrucks/EditPlaceholderModal/EditPlaceholderModal";
import WaypointGroupModal from "./../../components/page/placeholderTrucks/WaypointGroupModal/WaypointGroupModal";
import Loading from "../../components/wrapper/Loading/Loading";

import classes from '../../components/page/placeholderTrucks/EditPlaceholderModal/EditPlaceholderModal.module.scss'
import DataTable from "../../components/general/DataTable/DataTable";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SectionTitle from "../../components/general/SectionTitle/SectionTitle";
import { boxiPrimary } from "../../assets/style/colors";

const config = {
  headers: {
    "Content-Type": "application/json"
  }
};

class PlaceholderTruckPage extends Component {
  state = {
    placeholderTrucks: [],
    waypointGroups: [],
    waypointList: [],
    waypointListKeyPairs: [],
    editPlaceholderModalShow: false,
    selectedPlacholderTruckId: null,
    waypointGroupModalShow: false,
    waypointGroupModalEdit: false,
    selectedWaypointGroupId: null,
    isLoading: false,
    toastHeader: "",
    toastBody: "",
    isToastOpen: false,
    activeTab: 0,

    placeholderToDelete: null,
    isDeleteModalOpen: false,

    isWaypointGroupDeleteModalOpen: false,
    waypointGroupToDelete: false,

    placeholderRows: [],
    placeholderColumns: [
      { width: 20, field: 'id', headerName: '#', sortable: false },
      { flex: 1, field: 'name', headerName: 'Name' },
      { flex: 2, field: 'waypoint_names', headerName: 'Assigned Waypoint Groups' },
      { width: 30, field: 'btn', headerName: '', sortable: false, renderCell: (params) => {
        return (
          <EditIcon onClick={() => this.toggleSelectionEditModal(params.row.placeholder_id, false)} style={{ color: boxiPrimary, cursor: 'pointer' }}>
          </EditIcon>
        )} 
      },
      { width: 30, field: 'btn1', headerName: '', sortable: false, renderCell: (params) => {
        return (
          <DeleteForeverIcon onClick={() => this.toggleDeleteModal(params.row.placeholder_id)} color="error" style={{ cursor: 'pointer' }}>
          </DeleteForeverIcon>
        )} 
      }
    ],
    placeholderParams: {
      sortOrder: 'asc',
      sortBy: 'name',
      page: 0,
      pageSize: 10,
      search: null
    },
    isPlaceholderLoading: false,
    totalPlaceholder: 0,

    // waypoint group listing states
    wgRows: [],
    wgColumns: [
      { width: 20, field: 'id', headerName: '#', sortable: false },
      { flex: 2, field: 'name', headerName: 'Waypoint Group Name' },
      { width: 30, field: 'btn', headerName: '', sortable: false, renderCell: (params) => {
        return (
          <EditIcon onClick={() => this.toggleWaypointGroupEditModal(params.row.waypoint_group_id, false)} style={{ color: boxiPrimary, cursor: 'pointer' }}>
          </EditIcon>
        )} 
      },
      { width: 30, field: 'btn1', headerName: '', sortable: false, renderCell: (params) => {
        return (
          <DeleteForeverIcon onClick={() => this.toggleWaypointGroupDeleteModal(params.row.waypoint_group_id)} color="error" style={{ cursor: 'pointer' }}>
          </DeleteForeverIcon>
        )} 
      }
    ],
    wgParams: {
      sortOrder: 'asc',
      sortBy: 'name',
      page: 0,
      pageSize: 10,
      search: null
    },
    isWgLoading: false,
    totalWg: 0
  };

  getPlaceholders = (sortOrder = 'asc', sortBy = 'name', page = 0, pageSize = 10, search = null) => {
    const params = {
      sortOrder, 
      sortBy, 
      page, 
      pageSize,
      search
    }

    this.setState({
      placeholderParams: params,
      isPlaceholderLoading: true
    })

    axios.get(`${process.env.REACT_APP_API_HOST}/placeholder`, {params}).then((res) => {
      if (res.status === 200) {
        const rows = [];
        res.data.placeholders.map((placeholder, index) => {
          rows.push({
            id: (page * pageSize) + index + 1,
            placeholder_id: placeholder.placeholder_id,
            name: placeholder.name,
            campaign_id: placeholder.campaign_id,
            max_impressions: placeholder.max_impressions,
            min_impressions: placeholder.min_impressions,
            max_mileage: placeholder.max_mileage,
            min_mileage: placeholder.min_mileage,
            num_stops: placeholder.num_stops,
            start_point: placeholder.start_point,
            start_point_geo_coord: placeholder.start_point_geo_coord,
            use_weighting: placeholder.use_weighting,
            waypoint_ids: placeholder.waypoint_ids,
            waypoint_names: placeholder.waypoint_names.join(' | ')
          })
        });
        this.setState({
          placeholderRows: rows,
          isPlaceholderLoading: false,
          totalPlaceholder: res.data.rowCount
        })
      }
    })
  }

  getWaypointGroups = (sortOrder = 'asc', sortBy = 'name', page = 0, pageSize = 10, search = null) => {
    const params = {
      sortOrder, 
      sortBy, 
      page, 
      pageSize,
      search
    }

    this.setState({
      wgParams: params,
      isWgLoading: true
    })

    axios.get(`${process.env.REACT_APP_API_HOST}/waypoint_group`, {params}).then((res) => {
      if (res.status === 200) {
        const rows = [];
        res.data.waypoints.map((waypoint, index) => {
          rows.push({
            id: (page * pageSize) + index + 1,
            waypoint_group_id: waypoint.waypoint_group_id,
            name: waypoint.name
          })
        });
        this.setState({
          wgRows: rows,
          isWgLoading: false,
          totalWg: res.data.rowCount
        })
      }
    })
  }

  componentDidMount = async () => {
    this.getPlaceholders();
    this.getWaypointGroups();
    // await this.loadPage();
  };

  loadPage = async () => {
    this.setState({
      isLoading: true
    })
    await this.loadPlaceholders();
    await this.loadWaypoints();
    this.setState({
      isLoading: false
    })
  };

  async loadPlaceholders() {
    let placeholders = [];
    // get placeholder trucks
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/placeholder`, { withCredentials: true });
      placeholders =
        res.status === 200 && res.data.placeholders
          ? res.data.placeholders.map((truck) => [truck.placeholder_id, truck.name, truck.waypoint_names.join(" | ")])
          : [];
      this.setState({
        placeholderTrucks: placeholders
      });
    } catch (err) {
      console.log(err);
    }
  }

  async loadWaypoints() {
    let waypoints = [];
    let waypointList = [];
    let waypointListKeyPairs = [];
    // get waypoing groups
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/waypoint_group`, { withCredentials: true });
      waypoints =
        res.status === 200 && res.data.waypoints
          ? res.data.waypoints.map((waypoint) => {
              // create select options for waypoint groups
              waypointList.push(
                <option key={waypoint.waypoint_group_id} value={waypoint.waypoint_group_id}>
                  {waypoint.name}
                </option>
              );
              waypointListKeyPairs.push({
                value: waypoint.waypoint_group_id,
                label: waypoint.name,
              });
              return [waypoint.waypoint_group_id, waypoint.name];
            })
          : [];
      this.setState({
        waypointGroups: waypoints,
        waypointList: waypointList,
        waypointListKeyPairs: waypointListKeyPairs
      });
    } catch (err) {
      console.log(err);
    }
  }

  placeholderTruckHeaders = ["id", "Name", "Assigned Waypoint Groups"];
  placeholderTruckButtons = [
    {
      display: "Edit",
      onClickHandler: (index, id) => {
        this.setState({
          selectedPlacholderTruckId: id,
          editPlaceholderModalShow: true
        });
      }
    },
    {
      display: "Delete",
      onClickHandler: async (index, id) => {
        if (window.confirm(`Are you sure you want to delete this placeholder truck?\nThis action is irreversible.`)) {
          try {
            let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/placeholder/${id}`, { withCredentials: true });
            if (res.status === 200 && res.data.deleted_placeholder && res.data.deleted_placeholder[0].placeholder_id) {
              alert("Placeholder truck was deleted");
              window.location.reload();
              return;
            }
          } catch (err) {
            console.log(err);
          }
          alert("There was a problem deleting the placeholder truck");
        }
      }
    }
  ];

  waypointGroupHeaders = ["id", "Waypoint Group Name"];
  waypointGroupButtons = [
    {
      display: "Edit",
      onClickHandler: (index, id) => {
        this.setState({
          selectedWaypointGroupId: id,
          waypointGroupModalShow: true,
          waypointGroupModalEdit: true
        });
      }
    },
    {
      display: "Delete",
      onClickHandler: async (index, id) => {
        if (window.confirm(`Are you sure you want to delete this waypoint group?\nThis action is irreversible.`)) {
          try {
            let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/waypoint_group/${id}`, { withCredentials: true });
            if (res.status === 200 && res.data.deleted_waypoint && res.data.deleted_waypoint[0].waypoint_group_id) {
              // alert("Waypoint group was deleted");
              // window.location.reload();
              this.setState({
                toastHeader: 'Success',
                toastBody: 'Waypoint group was deleted!',
                isToastOpen: true,
                loading: false
              })
              await this.loadPage();
              setTimeout(() => {
                this.setState({
                  isToastOpen: false
                })
              }, 5000);
              return;
            }
          } catch (err) {
            console.log(err);
          }
          // alert("There was a problem deleting the waypoint group");
          this.setState({
            toastHeader: 'Failure',
            toastBody: 'There was a problem deleting the waypoint group!',
            isToastOpen: true,
            loading: false
          })
          setTimeout(() => {
            this.setState({
              isToastOpen: false
            })
          }, 5000);
        }
      }
    }
  ];

  addWaypointGroupClick = () => {
    this.setState({
      waypointGroupModalShow: true,
      waypointGroupModalEdit: false
    });
  };

  togglePlaceholderModal = async (isDismiss) => {
    this.setState({
      editPlaceholderModalShow: !this.state.editPlaceholderModalShow,
      selectedPlacholderTruckId: null
    });
    if (!isDismiss) await this.loadPage();
  };

  toggleWaypointModal = async () => {
    this.setState({
      waypointGroupModalShow: !this.state.waypointGroupModalShow,
      selectedWaypointGroupId: null
    });
    await this.loadPage();
  };

  toggleLoading = () => {
    this.setState({
      isLoading: !this.state.isLoading
    })
  }

  selectTab = (index) => {
    this.setState({
      activeTab: index
    })
    setTimeout(() => {
      index === 1 && window.dispatchEvent(new Event('resize'));
    }, 1);
  }

  componentWillUnmount() {
    // Remove the resize event listener when the component is unmounted
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    // Force the table to redraw when the window is resized
    this.forceUpdate();
  }

  toggleDeleteModal = (id) => {
    this.setState({
      placeholderToDelete: id
    }, () => {
      this.setState({
        isDeleteModalOpen: !this.state.isDeleteModalOpen
      })
    })
  }

  toggleSelectionEditModal = (id, fetchData) => {
    this.setState({
      selectedPlacholderTruckId: id,
      editPlaceholderModalShow: !this.state.editPlaceholderModalShow,
    })

    if (fetchData) this.getPlaceholders(this.state.placeholderParams.sortOrder, this.state.placeholderParams.sortBy, this.state.placeholderParams.page, this.state.placeholderParams.pageSize, this.state.placeholderParams.search)
  }

  deleteSelectionTruck = async (id) => {
    try {
      let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/placeholder/${this.state.placeholderToDelete}`, { withCredentials: true });
      if (res.status === 200 && res.data.deleted_waypoint && res.data.deleted_waypoint[0].waypoint_group_id) {
        this.setState({
          toastHeader: 'Success',
          toastBody: 'Selection Truck Deleted!',
          isToastOpen: true,
          isDeleteModalOpen: false
        })
        this.getPlaceholders(this.state.placeholderParams.sortOrder, this.state.placeholderParams.sortBy, this.state.placeholderParams.page, this.state.placeholderParams.pageSize, this.state.placeholderParams.search)
        setTimeout(() => {
          this.setState({
            isToastOpen: false
          })
        }, 3000);
      }
    } catch (err) {
      console.log(err);
      this.setState({
        toastHeader: 'Failure',
        toastBody: 'There was a problem deleting the selection Truck!',
        isToastOpen: true
      })
      setTimeout(() => {
        this.setState({
          isToastOpen: false
        })
      }, 3000);
    }
  }


  toggleWaypointGroupDeleteModal = (id) => {
    this.setState({
      waypointGroupToDelete: id
    }, () => {
      this.setState({
        isWaypointGroupDeleteModalOpen: !this.state.isWaypointGroupDeleteModalOpen
      })
    })
  }

  toggleWaypointGroupEditModal = (id, fetchData) => {
    this.setState({
      selectedWaypointGroupId: id,
      waypointGroupModalShow: !this.state.waypointGroupModalShow,
      waypointGroupModalEdit: !this.state.waypointGroupModalEdit
    })

    if (fetchData) this.getWaypointGroups(this.state.wgParams.sortOrder, this.state.wgParams.sortBy, this.state.wgParams.page, this.state.wgParams.pageSize, this.state.wgParams.search)
  }

  deleteWaypointGroup = async () => {
    try {
      let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/waypoint_group/${this.state.waypointGroupToDelete}`, { withCredentials: true });
      if (res.status === 200 && res.data.deleted_waypoint && res.data.deleted_waypoint[0].waypoint_group_id) {
        this.setState({
          toastHeader: 'Success',
          toastBody: 'Waypoint Group Deleted!',
          isToastOpen: true,
          isWaypointGroupDeleteModalOpen: false
        })
        this.getWaypointGroups(this.state.wgParams.sortOrder, this.state.wgParams.sortBy, this.state.wgParams.page, this.state.wgParams.pageSize, this.state.wgParams.search)
        setTimeout(() => {
          this.setState({
            isToastOpen: false
          })
        }, 3000);
      }
    } catch (err) {
      console.log(err);
      this.setState({
        toastHeader: 'Failure',
        toastBody: 'There was a problem deleting the waypoint group!',
        isToastOpen: true
      })
      setTimeout(() => {
        this.setState({
          isToastOpen: false
        })
      }, 3000);
    }
  }

  render() {
    const tableStyle = {
      boxShadow: "none"
    };
    const buttonStyle = {
      // width: "100px",
      backgroundColor: boxiPrimary,
      height: "34px",
      fontSize: "20px",
      padding: "0 15px",
      marginTop: "23px",
      marginRight: "20px",
      marginLeft: "10px",
      borderRadius: "16px",
      borderColor: boxiPrimary,
      float: "right"
    };
    return (
      <Fragment>
        {this.state.toastHeader === 'Success' && this.state.isToastOpen && 
          <Alert className={classes.alertMsg}>
            {this.state.toastBody}
          </Alert>
        }
        {this.state.toastHeader === 'Failure' && this.state.isToastOpen && 
          <Alert className={classes.alertMsg} color="danger">
            {this.state.toastBody}
          </Alert>
        }
        <Loading loading={this.state.isLoading} label="Loading..." />
        <Helmet>
          <title>Boxi Admin | Placeholder Trucks</title>
        </Helmet>
        <Row className="mb-4">
          <Col xs="5">
            <Title>Macros</Title>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div style={{ fontSize: 20, fontWeight: 500 }}>Add Macro</div>
              </AccordionSummary>
              <AccordionDetails>
                <PlaceholderTruckForm waypointList={this.state.waypointListKeyPairs} loadPage={this.getPlaceholders} />
              </AccordionDetails>
            </Accordion>
          </Col>
        </Row>
        <div className={classes.tabs}>
          <div onClick={() => this.selectTab(0)} className={this.state.activeTab === 0 ? classes.activeTab : classes.tab}>
            Selection Trucks
          </div>
          <div onClick={() => this.selectTab(1)} className={this.state.activeTab === 1 ? classes.activeTab : classes.tab}>
            Waypoint Groups
          </div>
        </div>

        <div className={`mt-4 ${this.state.activeTab === 0 ? classes.activeTable : classes.inactiveTable}`}>
          {/* <Table
            id="placeholder-truck-table"
            title="Selection"
            headers={this.placeholderTruckHeaders}
            buttons={this.placeholderTruckButtons}
            data={this.state.placeholderTrucks}
          /> */}
          <DataTable
            title="Selection"
            rows={this.state.placeholderRows}
            columns={this.state.placeholderColumns}
            fetchData={this.getPlaceholders}
            params={this.state.placeholderParams}
            isLoading={this.state.isPlaceholderLoading}
            rowCount={this.state.totalPlaceholder}
          />
        </div>

        <div className={`mt-4 ${this.state.activeTab === 1 ? classes.activeTable : classes.inactiveTable}`}>
          <div>
            <Button onClick={this.addWaypointGroupClick} style={buttonStyle} noShadow>
              Add New Group
            </Button>
            {/* <Table
              id="waypoint-group-table"
              title="Waypoint Groups"
              headers={this.waypointGroupHeaders}
              buttons={this.waypointGroupButtons}
              data={this.state.waypointGroups}
              sectionStyle={tableStyle}
              noSearch
            /> */}
            <DataTable
              title="Waypoint Groups"
              rows={this.state.wgRows}
              columns={this.state.wgColumns}
              fetchData={this.getWaypointGroups}
              params={this.state.wgParams}
              isLoading={this.state.isWgLoading}
              rowCount={this.state.totalWg}
            />
          </div>
        </div>

        {/* <Row>
          <Col xs="6">
            <Table
              id="placeholder-truck-table"
              title="Selection"
              headers={this.placeholderTruckHeaders}
              buttons={this.placeholderTruckButtons}
              data={this.state.placeholderTrucks}
            />
          </Col>
          <Col xs="6">
            <Section>
              <Button click={this.addWaypointGroupClick} colors={["#009FFD", "#11998E"]} style={buttonStyle} noShadow>
                Add New Group
              </Button>
              <Table
                id="waypoint-group-table"
                title="Waypoint Groups"
                headers={this.waypointGroupHeaders}
                buttons={this.waypointGroupButtons}
                data={this.state.waypointGroups}
                sectionStyle={tableStyle}
                noSearch
              />
            </Section>
          </Col>
        </Row> */}
        {this.state.editPlaceholderModalShow && <EditPlaceholderModal
          show={this.state.editPlaceholderModalShow}
          toggleModal={this.toggleSelectionEditModal}
          id={this.state.selectedPlacholderTruckId}
          waypointList={this.state.waypointListKeyPairs}
          toggleLoading={this.toggleLoading}
        />}
        <WaypointGroupModal
          show={this.state.waypointGroupModalShow}
          toggleModal={this.toggleWaypointGroupEditModal}
          edit={this.state.waypointGroupModalEdit}
          id={this.state.selectedWaypointGroupId}
        />

        <Modal className={classes.modalDialog} isOpen={this.state.isDeleteModalOpen} onClick={() => this.toggleDeleteModal(null)}>
          <ModalHeader toggle={this.toggleDeleteModal}>Delete Selection Truck?</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this selection truck?
            <br />
            This Action is irreversible!
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteSelectionTruck}>
              Delete
            </Button>
            <Button color="secondary" onClick={() => this.toggleDeleteModal(null)}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        <Modal className={classes.modalDialog} isOpen={this.state.isWaypointGroupDeleteModalOpen} onClick={() => this.toggleWaypointGroupDeleteModal(null)}>
          <ModalHeader toggle={this.toggleWaypointGroupDeleteModal}>Delete Selection Truck?</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this waypoint group?
            <br />
            This Action is irreversible!
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteWaypointGroup}>
              Delete
            </Button>
            <Button color="secondary" onClick={() => this.toggleWaypointGroupDeleteModal(null)}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(PlaceholderTruckPage);
